import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';


import * as inputConstants from './inputConstants';

import styles from './Input.scss';


function Input(
    {
        autoComplete,
        id,
        isDisabled,
        maxLength,
        name,
        onBlur,
        onChange,
        onChangeFilter,
        onClick,
        onFocus,
        placeholder,
        placeholderI18n,
        type,
        value
    }
) {

    const trim = input => {

        if (typeof input !== 'string') {

            return input;
        }

        return input.replace(/^\s+/gu, '')
            .replace(/\s{2,}$/gu, ' ');
    };

    const propagateValue = (value, callback) => {
        const cleanedValue = trim(value);
        callback(cleanedValue || null);
    };

    const {formatMessage} = useIntl();
    const placeholderValue = placeholderI18n
        ? formatMessage({id: placeholderI18n})
        : placeholder;

    const [currentValue, setCurrentValue] = useState(value || '');

    useEffect(() => {

        // if either field is set and the values differ, update with the external value
        if ((currentValue || value) && value !== currentValue) {
            setCurrentValue(value || '');
        }
    }, [value]);

    return (
        <input
            autoComplete={autoComplete}
            className={styles.input}
            disabled={isDisabled}
            id={id}
            maxLength={maxLength}
            name={name}
            onBlur={() => {
                if (onBlur) {
                    onBlur();
                }
            }}
            onChange={event => {
                let newValue = event.target.value;
                if (onChangeFilter) {
                    newValue = onChangeFilter(newValue);
                }
                setCurrentValue(newValue);
                if (onChange) {
                    propagateValue(newValue, onChange);
                }
            }}
            onClick={onClick}
            onFocus={onFocus}
            placeholder={placeholderValue}
            type={type}
            value={currentValue}
        />
    );
}


Input.propTypes = {
    autoComplete: PropTypes.oneOf(inputConstants.AUTOCOMPLETES),
    id: PropTypes.string,
    isDisabled: PropTypes.bool,
    maxLength: PropTypes.number,
    name: PropTypes.string.isRequired,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onChangeFilter: PropTypes.func,
    onClick: PropTypes.func,
    onFocus: PropTypes.func,
    placeholder: PropTypes.string,
    placeholderI18n: PropTypes.string,
    type: PropTypes.oneOf(inputConstants.TYPES),
    value: PropTypes.oneOfType(
        [
            PropTypes.string,
            PropTypes.number
        ]
    )
};

Input.defaultProps = {
    isDisabled: false,
    name: 'input',
    type: inputConstants.TYPE_TEXT
};


export default Input;
